<template>
  <validation-observer ref="obs">
    <v-container
      id="login"
      class="fill-height"
      tag="section"
    >
      <v-row justify="center">
        <v-slide-y-transition appear>
          <base-material-card
            color="success"
            light
            max-width="100%"
            width="400"
            class="px-5 py-3"
          >
            <template v-slot:heading>
              <div class="text-center">
                <h1 class="display-2 font-weight-bold mb-2">
                  Reset Password
                </h1>
              </div>
            </template>

            <v-card-text class="text-center">
              <validation-provider
                name="password"
                rules="required"
              >
                <v-text-field
                  ref="password"
                  v-model="form.password"
                  slot-scope="{errors,valid }"
                  color="secondary"
                  :error-messages="errors"
                  :success="valid"
                  label="Password..."
                  type="password"
                  prepend-icon="mdi-lock-outline"
                />
              </validation-provider>

              <validation-provider
                name="confirmation"
                rules="required|password:confirmation"
              >
                <v-text-field
                  v-model="form.password_confirmation"
                  slot-scope="{errors, valid}"
                  class="mb-8"
                  color="secondary"
                  :error-messages="errors"
                  :success="valid"
                  label="Password Confirm..."
                  type="password"
                  prepend-icon="mdi-lock-outline"
                />
              </validation-provider>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <pages-btn
                small
                color="success"
                :loading="resetLoader"
                :disabled="resetLoader"
                @click="requestUpdatePassword"
              >
                Update Password
                <template v-slot:loader>
                  <span class="custom-loader">
                    <v-icon light>mdi-cached</v-icon>
                  </span>
                </template>
              </pages-btn>
            </v-card-actions>
          </base-material-card>
        </v-slide-y-transition>
      </v-row>
    </v-container>
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      :color="colorValue"
    >
      {{ text }}
    </v-snackbar>
  </validation-observer>
</template>

<script>
  import { _resetPassword } from '@/services/Auth'

  import {
    ValidationObserver,
    ValidationProvider,
  //  withValidation
  } from 'vee-validate'

  export default {
    name: 'ForgotPasswordForm',
    inject: ['$validator'],
    components: {
      ValidationProvider,
      ValidationObserver,
      PagesBtn: () => import('./components/Btn'),
    },
    data: () => ({
      form: {
        password: '',
        password_confirmation: '',
      },
      resetLoader: false,
      snackbar: false,
      text: '',
      timeout: 5000,
      colorValue: '',
    }),
    mounted () {
      if (this.$store.state.user.isLoggedIn && this.$store.state.user.role === 'ADMIN') {
        this.$router.push('admin/users')
      } else if (this.$store.state.user.isLoggedIn && this.$store.state.user.role === 'USER') {
        this.$router.push('/dashboard')
      }
      console.log()
    },
    created () {
      this.$validator.extend('password', {
        validate: () => this.form.password === this.form.password_confirmation,
        getMessage () {
          return `The confirm password does not match`
        },
        params: [{
          name: 'confirmation',
          isTarget: true,
        }],
      })
    },
    methods: {

      async requestUpdatePassword () {
        const result = await this.$refs.obs.validate()
        if (result) {
          this.resetLoader = true
          let formData = {
            hash: this.$route.params.token,
            email: this.$route.params.email,
            password: this.form.password,
            password_confirmation: this.form.password_confirmation,
          }
          _resetPassword(formData).then(
            response => {
              this.snackbar = true
              this.text = response.data.message
              this.resetLoader = false
              if (response.data.success) {
                this.colorValue = 'success'
                this.$router.push('/login')
              } else {
                this.colorValue = 'error'
              }
            }, error => {
              this.snackbar = true
              this.colorValue = 'red'
              this.text = error.data.message
              this.resetLoader = false
            }
          )
        }
      },

    },

  }

</script>

<style lang="css">
  .h40 {
    height: 40px
  }

  .v-expansion-panel {
    background-color: orange
  }
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }

</style>
